<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-md-6" v-for="(type, index) in ['male', 'female']" :key="index">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col-12">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t(statusInfo(type).label)}}</h6>
                                <span class="h2 mb-0" v-if="reports[type]">{{reports[type].count || 0 }}</span>
                                <span class="h2 mb-0" v-else>0</span>

                                <span
                                    v-if="reports[type]"
                                    class="badge badge-soft-secondary mt-n2 ml-2"
                                    :class="{'badge-soft-success':reports[type].percentage>0, 'badge-soft-danger':reports[type].percentage<0}"
                                >
                                    <span
                                        class="fe"
                                        :class="{'fe-arrow-up':reports[type].percentage>0, 'fe-arrow-down':reports[type].percentage<0}"
                                    ></span>
                                    {{reports[type].percentage}} %
                                </span>
                            </div>
                            <div class="col-12 mt-4">
                                <div v-for="(group, index) in byAge[type]" :key="index">
                                    <div class="row mt-1" v-if="group._id || group.count">
                                        <div class="col-sm-10">
                                            <span v-if="group._id">{{group._id}}</span>
                                            <span v-else>{{$t('Unknown')}}</span>
                                        </div>
                                        <div class="col-sm-2 text-right">
                                            <span>{{group.count}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-auto">
                                <span class="h2 fe text-muted mb-0" :class="statusInfo(type).icon"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('By gender')}}</h6>
                                <Doughnut :chartData="chartData" scheme="HueCircle19"></Doughnut>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('By age')}}</h6>
                                <Doughnut :chartData="byAge['all'] || []" scheme="HueCircle19"></Doughnut>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('By source')}}</h6>
                                <Doughnut :chartData="sourceChartData" scheme="HueCircle19"></Doughnut>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import status from "@/filters/status.js";
import AgeFilter from "@/components/AgeFilter.vue";
import Doughnut from "@/components/Charts/Doughnut.vue";
import { mapActions } from "vuex";

export default {
    components: {
        Doughnut,
        AgeFilter
    },
    props: { user: Array, dates: Object, branchesId: Array },
    data() {
        return {
            sourceChartData: [],
            labels: [
                { _id: "", count: 0 },
                { _id: "0 - 14", count: 0 },
                { _id: "15 - 24", count: 0 },
                { _id: "25 - 44", count: 0 },
                { _id: "45 - 64", count: 0 },
                { _id: "65+", count: 0 }
            ],
            ages: {},
            chartData: [],
            byAge: {},
            params: {
                query: {}
            },
            reports: {}
        };
    },
    computed: {},
    watch: {
        user(newUser) {
            this.fetchReport();
        },

        branchesId(newValue) {
            this.fetchReport();
        },

        dates(dates) {
            this.fetchReport();
        },

        ages(ages) {
            this.fetchReport();
        }
    },
    created() {
        this.fetchReport();
    },
    methods: {
        ...mapActions("customer-reports", ["find"]),

        translate(values) {
            // if (!values) return [];
            // return this.labels.map({})
            // return values.map(el => ({_id: this.$t(el._id), count: el.count}))
        },

        fetchReport() {
            let query = {};
            if (this.ages)
                query.age = this.ages;

            if (this.dates.start)
                query.createdAt = {
                    $gte: this.dates.start,
                    $lte: this.dates.end
                };

            if (this.branchesId.length > 0)
                query.branchesId = this.branchesId;

            if (this.user.length > 0)
                query.user = { $in: this.user };

            this.reports = {};
            this.chartData = [];
            this.sourceChartData = [];
            this.find({ query }).then(data => {
                if (data.length <= 0) return;
                data = data[0];
                this.chartData = data.byGender;
                data.byGender.forEach(item => {
                    item.slug = item._id;
                    item._id = this.$t(item._id);
                    this.$set(this.reports, item.slug, item);
                });
                this.sourceChartData = data.bySource.map(el => {
                    el.slug = el._id;
                    el._id = el.label;
                    if (!el._id) {
                        el._id = this.$t("Unknown");
                    }
                    return el;
                });
                this.byAge = data.byAge;
                Object.keys(this.byAge).forEach(key => {
                    let res = this.$copy(this.labels);
                    this.byAge[key].forEach(item => {
                        const idx = res.findIndex(el => el._id === item._id);
                        if (idx !== -1) {
                            res[idx] = item;
                        }
                    });
                    this.byAge[key] = res.map(el => {
                        if (!el._id) el._id = this.$t("Unknown");
                        return el
                    });
                });
            });
        },

        statusInfo(value) {
            return status(value);
        }
    }
};
</script>

<style>
</style>
